import { getUUID, PlaybackEventEmitter, PlaybackEvent, } from '@annunciate/core';
import { fetchValidStream } from '@annunciate/query';
export const getStreamFromContent = async (requestedContent, client) => {
    const uuid = await getUUID(true);
    let content = requestedContent;
    let stream;
    try {
        let result;
        try {
            result = await fetchValidStream(client, requestedContent.id);
        }
        catch (err) {
            PlaybackEventEmitter.emit(PlaybackEvent.ENTITLEMENT_ERROR, {
                content: requestedContent,
                message: `It looks like you don't have access to this item.`,
            });
        }
        content = result?.content;
        stream = result?.stream;
    }
    catch (err) {
        PlaybackEventEmitter.emit(PlaybackEvent.UNKOWN_ERROR, {
            content: requestedContent,
            message: `An unknown error has occurred. Please try again or contact support.`,
        });
    }
    return {
        content,
        stream,
    };
};
//# sourceMappingURL=getStreamFromContent.web.js.map